module.exports = __webpack_public_path__ + "static/img/jx-xxzy.a8feca4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/jx-xxzy.png
// module id = vfjJ
// module chunks = 0